import React from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';

import logo from '../../assets/images/logo.svg';
import quoteMediaLogo from '../../assets/images/quote_media_logo.png';
import FooterText from './FooterText';
import { footerPages } from '../SimplePages';

import './index.css';


// update whenever a new path with quote media data is added
const SHOW_QUOTEMEDIA_PATHS = [
  '/securities',
  '/portfolio',
  '/security-trade',
];

const Component = ({
  showQuoteMedia,
  location,
}) => {
  const quoteMediaFooter = (
    <div styleName="quoteMediaSection">
      Market data copyright &copy; 2018 <a href="http://www.quotemedia.com/">Quote Media</a>.
      Data delayed 15 minutes unless otherwise indicated (view
      &nbsp;<a href="http://www.quotemedia.com/legal/tos/#times">delay times</a> for all exchanges).
      <br />
      Market data powered by <a href="http://www.quotemedia.com/">Quote Media</a>. <a href="http://www.quotemedia.com/legal/tos/">Terms of Use</a>
      <br />
      <img
        src={quoteMediaLogo}
        alt="Quote Media"
        styleName="quoteMediaLogo"
      />
    </div>
  );

  const show = SHOW_QUOTEMEDIA_PATHS.reduce((acc, p) => {
    if (acc) {
      return acc;
    }
    return location.pathname.includes(p);
  }, showQuoteMedia);

  return (
    <div styleName="footerMain">
      <div styleName="sectionContainer">
        <div styleName="footerLogoSection">
          <img
            src={logo}
            alt="My IPO logo"
            styleName="footerLogo"
          />
          <Link
            to="/about"
            styleName="footerTopLink"
          >
            About
          </Link>
          <a href="https://www.myipo.com/offers" styleName="footerTopLink">Offers</a>
        </div>
        <div>
          <FooterText />
        </div>
        <div styleName="subLinksSection">
          {footerPages.map(({
              path, title, openSeparately, footerLinkTitle,
            }) => (
            path.startsWith('http') || openSeparately ? (
              <a
                key={path}
                href={path}
                target="_blank"
                styleName="footerSubLink"
              >
                {footerLinkTitle || title}
              </a>
            ) : (
              <Link
                key={path}
                to={path}
                target={path.startsWith('http') ? '_blank' : undefined}
                styleName="footerSubLink"
              >
                {footerLinkTitle || title}
              </Link>
            )))}
        </div>
        <div>
          { show && quoteMediaFooter }
        </div>
      </div>
    </div>
  );
};

Component.displayName = 'Footer';

export default withRouter(Component);



// WEBPACK FOOTER //
// ./src/components/Footer/index.js